import { styled } from '@mui/material'
import { AUDIENCE_COLORS } from '@npm-client-frontends/shared-constants'
import { AudienceGroups } from '@npm-client-frontends/client-frontends-shared-types'

const SVG = styled('svg')(() => ({
  width: 14,
  height: 14,
  '.ut-svg': {
    fill: AUDIENCE_COLORS.UTILITY_SCALE,
    stroke: AUDIENCE_COLORS.UTILITY_SCALE,
  },
  '.dg-svg': {
    fill: AUDIENCE_COLORS.DISTRIBUTED_GENERATION,
    stroke: AUDIENCE_COLORS.DISTRIBUTED_GENERATION,
  },
  '.dc-svg': {
    fill: AUDIENCE_COLORS.DATA_CENTERS,
    stroke: AUDIENCE_COLORS.DATA_CENTERS,
  },
  '.eur-svg': {
    fill: AUDIENCE_COLORS.EUROPE,
    stroke: AUDIENCE_COLORS.EUROPE,
  },
}))

export default ({ audiences }: { audiences: AudienceGroups[] }) => {
  const max = 50

  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="h-6 w-6"
    >
      <rect
        className={`${audiences[0].toLowerCase()}-svg`}
        x="0"
        y="0"
        width={max}
        height={max}
      />
    </SVG>
  )
}
